import { mutations, actions } from "./actions";

const state = {
    searchSchool: [],
    isLast: false,
    isEmpty: false,

    // detail
    detail: null,
    isNotFound: null,

    // list
    isNoticeLast: false,

    pages: {},
    fixedScroll: {},
    boardList: [], // id, name, type, uid -> schoolBoards
    schoolBoards: {},
    schoolBoardsLoading: {},

    loading: {
        search: false,
        detail: false
    }
};

const getters = {
    eachSchoolMenu(state, _, rootState) {
        const { boardIcon, typeIconV3 } = rootState.notice;
        const defaultItem = [{ title: "이 학교의 소식", children: [] }];

        if (state.detail) {
            const schoolMenu = state.boardList.map(({ id, name }) => {
                const backNumber = id.toString().slice(id.length - 2, id.length);
                const index = parseInt(backNumber) - 1;

                return {
                    name,
                    link: `/school/${state.detail.schoolId}/${id}`,
                    icon: boardIcon[index] || "book"
                };
            });

            // [{ name: "전체", link: "/newsfeed", icon: "book" }, ...schoolMenu];

            defaultItem[0].children = schoolMenu;
        }

        return defaultItem;
    },

    getBoardId(state) {
        return state.boardList;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
